import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const LockIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Lock`} {...props}>
    <Path
      stroke="currentColor"
      strokeWidth={1.5}
      fill="none"
      d="M3 6a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6ZM6 4.5V3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1.5"
    />
    <Path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M8 10.5v-2"
    />
  </Icon>
);
